<template>
    <u class="cursor-pointer">
        <slot/>
    </u>
</template>